import React from 'react';

const variantClasses = {
  primary:        'btn-primary',
  secondary:      'btn-secondary',
  danger:         'btn-danger',
  'danger-outline': 'btn-danger-outline',
  ghost:          'btn-ghost',
};

const sizes = {
  sm: 'h-8 px-3 text-[0.875rem] gap-1.5',
  md: 'h-10 px-6 text-[1rem] gap-2',
  lg: 'h-12 px-6 text-[1rem] gap-2',
};

const iconOnlySizes = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconOnly = false,
  disabled = false,
  loading = false,
  className = '',
  ...props
}) {
  const baseClasses = 'inline-flex items-center justify-center font-semibold rounded-full cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed';
  const sizeClasses = iconOnly ? iconOnlySizes[size] : sizes[size];
  const vClass = variantClasses[variant] || variantClasses.primary;

  return (
    <button
      className={`${baseClasses} ${vClass} ${sizeClasses} ${className}`}
      style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      ) : (
        <>
          {icon && <span className="flex-shrink-0">{icon}</span>}
          {!iconOnly && children}
        </>
      )}
    </button>
  );
}
